import PreloadImage from "./preloadImage"
import Lead from "./lead"

import { useEffect, useMemo, useState } from "react"
import { useToast } from './useToast';

const User = (props) => {
    const [avatar, setAvatar] = useState(null)
    const [name, setName] = useState(null)
    const [gender, setGender] = useState(null)
    const [personalImageUrl, setPersonalImageUrl] = useState(null)
    const [isClick, setClick] = useState(null)
    const [isLogin, setIsLogin] = useState(false);

    let userAgent = navigator.userAgent;
    let isiOS = !!userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    var isAndroid = userAgent.indexOf('Android') > -1 || userAgent.indexOf('Linux') > -1; //android终端或者uc浏览器
    var isWeixin = userAgent.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
    const showToast = useToast();
    const isSafari = () => {
        // 判断用户代理是否包含 "Safari" 但不包含 "Chrome"
        const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);

        return isSafari;
    }
    useEffect(() => {
        const myHeaders = new Headers();
        if (props.data.shareKey) {
            //获取用户头像和名字
            fetch(`${process.env.REACT_APP_BASE_URL_USER}/server/v1/free/user/info?shareKey=${props.data.shareKey}&fields=userProfile,user`, {
                method: 'GET',
                headers: myHeaders,
                mode: 'cors',
                cache: 'default'
            }).then(response => response.json())
                .then(res => {
                    if (res.code === 0) {
                        const { userResource, profileResource } = res.data
                        setAvatar(profileResource.avatarUrl)
                        setName(userResource.firstName)
                        setGender(userResource.gender)
                        setPersonalImageUrl(profileResource.personalImageUrl)
                    }
                })
        } else {
            setGender(0)
        }
    }, [props.data])
    // const getCookie = (name) => {
    //     let cookies = document.cookie.split('; ')

    //     for (let i = 0; i < cookies.length; i++) {
    //         let parts = cookies[i].split('=')
    //         if (parts[0] === name) {
    //             return parts[1]
    //         }
    //     }
    //     return ''
    // }
    useEffect(() => {
        if (isiOS && !isSafari() && !isWeixin) {
            showToast('为了保证您可以正常体验功能，请在 Safair 浏览器中打开此页面地址');
        }
        //判断cookie下边有没有用户信息
        // const cookie = getCookie('userMsg');
        if (props.data.ic) {
            let urlObj = new URL(window.location.href+'&islogin=1');
            urlObj.searchParams.delete('ic');
            const targetUrl = urlObj.toString();
            window.location.replace(process.env.REACT_APP_LOGIN_URL + '?inviteCode=' + props.data.ic + '&targeturl=' + encodeURIComponent(targetUrl));
        }
        setIsLogin(!!props.data.islogin)
    }, [])
    useEffect(() => {
        if (window.JMLink && isLogin) {
            new window.JMLink({
                autoLaunchApp: false,
                jmlink: process.env.REACT_APP_JMLINK,// 短链地址
                button: document.querySelector('#add'),
                params: { ttpath: window.location.href },
                directDownload: true
            });
        }
    }, [isWeixin, isLogin])
    const addFriend = () => {
        if (isLogin) {
            if (isiOS) {
                window.location.href = process.env.REACT_APP_IOS_PATH;
            }
            if (isAndroid) {
                window.location.href = process.env.REACT_APP_ANDROID_PATH;
            }
            return;
        }
        
        const timeout = 2000; // 超时时间

        let startTime = Date.now();
        // 创建一个 iframe 用于尝试打开 app
        window.location.href = process.env.REACT_APP_HREF
        // 设置超时检查是否打开了 App
        setTimeout(() => {
            // 如果超时后仍在页面内，表示未安装 App
            if (Date.now() - startTime < timeout + 100) {
                window.location.replace(process.env.REACT_APP_LOGIN_URL + '?targeturl=' + encodeURIComponent(window.location.href) + '&su=' + props.data.su)
            }
        }, timeout);
    }
    const toLogin = () => {
        window.location.replace(process.env.REACT_APP_LOGIN_URL + '?targeturl=' + encodeURIComponent(window.location.href) + '&su=' + props.data.su)
    }
    return (
        <div className="user-wrapper">
            {isWeixin && isClick && <Lead />}
            <div className="bg">
                <PreloadImage src={require('../assets/img/user_bg.png')} alt=''></PreloadImage>
            </div>
            <div id="user_content">
                <div className="person">
                    <div className="user-info">
                        <div className="avatar">
                            <img src={avatar} alt="" />
                        </div>
                        <div className="name">
                            {name}
                        </div>
                    </div>

                    <div className="model">
                        <img className={[gender == 1 ? 'male':'female'].join(' ')} src={personalImageUrl} alt="" />
                    </div>

                </div>
                {useMemo(() => {
                    if (isWeixin) {
                        return (
                            <div id="add-v1" onClick={() => setClick(true)}>
                                添加TA为好友
                            </div>
                        )
                    }
                    if (isLogin) {
                        return (
                            <div id="add">
                                打开App
                            </div>
                        )
                    } else {
                        return (
                            <div id="add-v1" onClick={toLogin}>
                                添加TA为好友
                            </div>
                        )
                    }
                }, [isLogin])}
            </div>
        </div>
    )
}
export default User
